<script>
import NoRecordFound from '@/src/components/_norecord-found'
export default {
  components: {
    NoRecordFound,
  },
  props: {
    driverInformation: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    driversInformation() {
      return this.driverInformation || []
    },
  },
  methods: {
    formatDisplay(value) {
      return value || ''
    },
  },
}
</script>

<template>
  <div>
    <div v-if="driversInformation.length" class="baseContentFont">
      <div
        v-for="(item, i) in driversInformation"
        :key="i"
        :class="$style.relativesContainer"
        class="px-3 py-1 mx-1 my-1 border"
      >
        <b-row>
          <b-col md="4">
            <div class="d-flex">
              <div><b>State/License#: </b><span v-if="item.originState || item.driverLicense">
                  {{
                    formatDisplay(item.originState) +
                      '/' +
                      formatDisplay(item.driverLicense)
                  }}
                </span>
              </div>
            </div>

            <div class="d-flex">
              <div><b>Class: </b>{{ formatDisplay(item.licenseClass) }}</div>
            </div>

            <div class="d-flex">
              <div><b>Name: </b>{{ formatDisplay(item.name) }}</div>
            </div>

            <div class="d-flex">
              <div><b>Address: </b>{{ formatDisplay(item.address) }}
              </div>
            </div>

            <div class="d-flex">
              <div><b>OOS Prev State/License#: </b><span v-if="item.oosPrevState || item.oosPrevDLNumber">
                  {{
                    formatDisplay(item.oosPrevState) +
                      '/' +
                      formatDisplay(item.oosPrevDLNumber)
                  }}
                </span>
              </div>
            </div>
          </b-col>

          <b-col md="4">
            <div class="d-flex">
              <div><b>Status: </b>{{ formatDisplay(item.status) }}</div>
            </div>
            <div class="d-flex">
              <div><b>Type: </b>{{ formatDisplay(item.licenseType) }}
              </div>
            </div>
            <div class="d-flex">
              <div><b>Gender: </b>{{ formatDisplay(item.gender) }}</div>
            </div>
          </b-col>
          <b-col md="4">
            <div class="d-flex">
              <div><b>Expiration Date: </b>{{ formatDisplay(item.expirationDate) }}
              </div>
            </div>
            <div class="d-flex">
              <div><b>Issued Date: </b>{{ formatDisplay(item.issueDate) }}</div>
            </div>
            <div class="d-flex">
              <div><b>Date of Birth: </b>{{ formatDisplay(item.dob) }}</div>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
    <NoRecordFound v-else class="mx-1"></NoRecordFound>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.relativesContainer {
  padding: 5px 10px;
}
.relativesContainer:nth-child(odd) {
  background: #fff;
}
.relativesContainer:nth-child(even) {
  background: #eee;
}

// .w40 {
//   width: 40% !important;
// }

// .w60 {
//   width: 60% !important;
// }
</style>
